import { motion } from 'framer-motion';
import { SectionHeading, ScrubbingText } from '../ui/SharedUI';

export function ArchitectureSection() {
  return (
    <section className="relative z-10 w-full py-20 lg:py-40 px-6 bg-gradient-to-b from-transparent via-[#030303] to-transparent border-t border-white/5">
      <div className="max-w-7xl mx-auto flex flex-col lg:flex-row gap-12 lg:gap-16 items-center">
        <div className="w-full lg:w-1/2">
          <SectionHeading title="The Architecture" subtitle="Emilia Ivanova Industries" />
          <div className="space-y-8 mt-12 text-sm md:text-lg lg:text-xl leading-relaxed text-center lg:text-left font-serif lg:pr-12">
            <ScrubbingText text="We are not just building software; we are building a mathematical advantage. Traditional scaling requires hiring costly human teams for every new task. Our architecture decouples growth from labor, replacing crushing overhead with scalable, fraction-of-a-cent compute power." />
            <ScrubbingText text="This is the transition from expensive, error-prone workflows to a high-speed, autonomous ecosystem. Whether generating 10,000 interactions or building high-end brand assets, we eliminate the immense payroll barriers that hold agencies back." />
            <ScrubbingText text="What you see on social media is the aesthetic. What you get here is the machine. We partner with ambitious founders and elite brands to deploy architectures that give them their time and capital back." />
          </div>
        </div>

        {/* Split Parallax Images */}
        <div className="w-full lg:w-1/2 grid grid-cols-2 gap-4">
          <motion.img
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 1 }}
            alt="Emilia Ivanova Architecture Visual 1"
            src="/emilia-11-thumb-opt.webp" className="w-full h-full object-cover rounded aspect-[4/5] opacity-80 lg:opacity-60 lg:hover:opacity-100 transition-opacity duration-700"
          />
          <motion.img
            initial={{ opacity: 0, scale: 0.9, y: 0 }}
            whileInView={{ opacity: 1, scale: 1, y: 40 }}
            viewport={{ once: true }}
            transition={{ duration: 1, delay: 0.2 }}
            alt="Emilia Ivanova Architecture Visual 2"
            src="/emilia-12-thumb-opt.webp" className="w-full h-full object-cover rounded aspect-[4/5] opacity-80 lg:opacity-60 lg:hover:opacity-100 transition-opacity duration-700 lg:mt-0"
          />
        </div>
      </div>
    </section>
  );
}
